/* slider
---------------------------------------------------------- */
const slider = function () {

  const heroSlider = new Swiper('.grid--blog', {
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 3000,
    },
    pagination: {
      el: '.hero-swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.hero-swiper-button-next',
      prevEl: '.hero-swiper-button-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 1.1,
        centeredSlides: true,
        loopedSlides: 3,
      },
      768: {
        slidesPerView: 'auto',
        // slidesPerView: 3,
        // centeredSlides: true,
        spaceBetween: 40,
      },
    },
  });

  const staffPicksSlider = new Swiper('.staff-picks-swiper-container', {
    slidesPerView: 1.5,
    spaceBetween: 40,
    loop: true,
    loopedSlides: 3,
    centeredSlides: true,
    speed: 1000,
    autoplay: {
      delay: 3000,
    },
    pagination: {
      el: '.staff-picks-swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.staff-picks-swiper-button-next',
      prevEl: '.staff-picks-swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2.4,
        spaceBetween: 32,
      },
    },
  });

}




/* Init
---------------------------------------------------------- */
slider();
